import React from 'react';

const ProgressBar = ({ currentIndex, totalQuestions }) => {
  // Calculate percentage more accurately
  const progressPercentage = ((currentIndex + 1) / totalQuestions) * 100;
  
  // Determine if we should show all steps or condensed steps based on total questions
  const showAllSteps = totalQuestions <= 10;
  const steps = showAllSteps 
    ? Array.from({ length: totalQuestions }) 
    : [0, 0.25, 0.5, 0.75, 1].map(p => Math.floor(p * (totalQuestions - 1)));
  
  return (
    <div className="w-full">
      {/* Text indicators */}
      <div className="flex justify-between text-sm text-arc-muted mb-1">
        <span>Question {currentIndex + 1} of {totalQuestions}</span>
        <span>{Math.round(progressPercentage)}% Complete</span>
      </div>
      
      {/* Main progress bar */}
      <div className="h-2 bg-arc-elevated rounded-full overflow-hidden border border-slate-600">
        <div 
          className="h-full bg-gradient-to-r from-blue-500 to-blue-400 rounded-full transition-all duration-300 ease-out shadow-sm"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      
      {/* Step indicators for larger screens */}
      <div className="hidden md:flex justify-between mt-2 px-1">
        {showAllSteps ? (
          // Show all steps if there aren't too many
          Array.from({ length: totalQuestions }).map((_, idx) => (
            <div 
              key={idx}
              className={`h-2 w-2 rounded-full transition-all duration-300 border ${
                idx <= currentIndex 
                  ? 'bg-arc-gold border-blue-400 shadow-sm shadow-blue-500/50' 
                  : 'bg-white/10 border-slate-500'
              }`}
            />
          ))
        ) : (
          // Show condensed steps if there are many questions
          steps.map((stepIndex, idx) => (
            <div 
              key={idx}
              className={`h-2 w-2 rounded-full transition-all duration-300 border ${
                stepIndex <= currentIndex 
                  ? 'bg-arc-gold border-blue-400 shadow-sm shadow-blue-500/50' 
                  : 'bg-white/10 border-slate-500'
              }`}
            />
          ))
        )}
      </div>
      
      {/* Simple text indicator for small screens */}
      <div className="md:hidden text-xs text-center mt-2 text-arc-muted">
        {Array.from({ length: Math.min(5, totalQuestions) }).map((_, idx) => {
          const stepSize = totalQuestions / Math.min(5, totalQuestions);
          const stepIndex = Math.floor(idx * stepSize);
          return (
            <span 
              key={idx}
              className={`inline-block mx-1 transition-colors duration-300 ${
                stepIndex <= currentIndex ? 'text-arc-gold font-medium' : 'text-arc-dim'
              }`}
            >
              {idx === 0 ? 'Start' : idx === Math.min(5, totalQuestions) - 1 ? 'End' : `${idx}`}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;